import { FlexSpacer } from 'ui/flexSpacer';
import { Skeleton } from 'ui/skeleton';

export const PerformanceOverTimeContentLoading = () => {
  return (
    <FlexSpacer flexDirection="row" justifyContent="space-between" alignItems="center">
      <Skeleton height={400} width={744} />
      <Skeleton height={400} width={400} />
    </FlexSpacer>
  );
};
